// extracted by mini-css-extract-plugin
export default {"buttonsContainer":"AllTypesBonusesList_buttonsContainer--m5A","skeletWrapper":"AllTypesBonusesList_skeletWrapper--Okj","skeletHeight":"AllTypesBonusesList_skeletHeight--CMP"};